import PaymodeButton from './PaymodeButton';

export default PaymodeButton;
